
  import { Component, Vue, Prop }                       from 'vue-property-decorator';
  import { Action, Getter }                             from 'vuex-class';
  import { EventBus,
           ConfigService,
           ConfigThemeService,
           BotInitializationService,
           ResponsiveUiHelper }                         from '../..';
  import   EmotionAvatarComponent                       from '../../features/avatar/EmotionAvatarComponent.vue';
           
  @Component({
    name: 'HeaderComponent',
    components: {
      EmotionAvatarComponent,
    }
  })
  export default class HeaderComponent extends Vue {
    @Prop() onWidgetScrolled!: boolean;
    @Prop() calculatedHeaderHeight!: string;
    @Action('setConversationPanelState', { namespace: 'conversationSession' }) setConversationPanelState: any;
    @Action('resetNotification', { namespace: 'messages' }) resetNotification: any;
    @Getter('isEmbeddedMode', { namespace: 'conversationSession' }) isEmbeddedMode!: boolean | undefined;

    isFullscreenDisplay: boolean = false;

    get isPresentationAvatarMode() {
      // If animated emotion active set presentation mode to false in order to use small avatar width 
      // the canvas for GIF avatars can not be resized then we take the smaller size to fit in presentation or collapsed header modes
      return false;
    }

    created() {   
      EventBus.$on('ON_OPEN_CONVERSATION_PANEL_EVENT', () => {
        this.openConversationPanel();
      });
      EventBus.$on('ON_RESIZE_SCREEN_MODE', (isFullscreen: boolean) => {
        this.isFullscreenDisplay = isFullscreen;
      });
      this.isFullscreenDisplay = ResponsiveUiHelper.isFullscreenDisplay(this.$vuetify);
    }


    destroyed() {
      EventBus.$off('ON_OPEN_CONVERSATION_PANEL_EVENT');
      EventBus.$off('ON_RESIZE_SCREEN_MODE');
    }

    openConversationPanel() {
      this.setConversationPanelState(true);
      if (this.isEmbeddedMode && this.isFullscreenDisplay) {
        ResponsiveUiHelper.showChatbox();
      }
    }

    closeConversationPanel() {
      this.resetNotification()
      this.setConversationPanelState(false);
      if (this.isEmbeddedMode && this.isFullscreenDisplay) {
        ResponsiveUiHelper.hideChatbox();
      }      
      BotInitializationService.toggleSynapseClassInDOM(false, ConfigService.getElementClassOrIdToHideInFullScreenMode(), ConfigService.getElementClassOrIdToHideInFullScreenModePrefixed());
      BotInitializationService.toggleSynapseClassInDOM(false, "body", ConfigService.getSynapseClassToHideScrollbar());

      // hide all elements with the class "str-msg-bot-content"
      document.querySelectorAll('[id="str-msg-bot-content"]').forEach((element) => {
        element.setAttribute('aria-hidden', 'true');
      });

      // check if the drawer is closed
      EventBus.$emit('ON_CLOSE_CONVERSATION_PANEL');
    }

    mounted() {
      document.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('close-chatbot', this.closeConversationPanel);
    }

    beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeydown);
    }

    handleKeydown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        this.closeConversationPanel();
      }
    }

    /** ******************************************************************** */
    /**                           HEADER STYLES                              */
    /** ******************************************************************** */

    get headerWelcomeTitle() {
      return ConfigService.getHeaderWellcomeTextContent();
    }

    get getHeaderMaxTextHeight(){
      return `${ConfigThemeService.getHeaderMaxTextHeight()}px`
    }

    get headerTitle() {
      console.log('headerTitle')
      return ConfigService.getHeaderTextContent();
    }

    get isDarkHeaderAppliedThemeActive() {
      return (ConfigThemeService.getHeaderAppliedTheme() === 'dark');
    }

    get headerStyles() {
      return !this.onWidgetScrolled ? ConfigThemeService.getHeaderStyles(this.$vuetify) 
                                    : ConfigThemeService.getCollapsedHeaderStyles(this.$vuetify);
    }

    get headerContainerStyles() {
      return !this.onWidgetScrolled ? { backgroundColor: 'transparent !important'} 
                                    : ConfigThemeService.getCollapsedHeaderContainerStyles(this.$vuetify);
    }

    get headerCollapsedStyles() {
      return ConfigThemeService.getCollapsedHeaderStyles(this.$vuetify);
    }

    get headerInnerContainerStyles() {
      return ConfigThemeService.getHeaderInnerContainerStyles(this.$vuetify);
    }

    get collapsedHeaderIconsColor() {
      return ConfigThemeService.getCollapsedHeaderItemsColor(this.$vuetify);
    }
    
    get headerItemsColor() {
      return ConfigThemeService.getHeaderItemsColor(this.$vuetify);
    }

    get headerIconsStyles() {
      return ConfigThemeService.getHeaderIconsStyles(this.$vuetify);
    }

    get headerHideConversationPanelIcon() {
      return ConfigThemeService.getHeaderHideConversationPanelIcon();
    }

    get headerBackgroundImg() {
      return ConfigThemeService.getHeaderBackgroundImg();
    }

    get headerBackgroundImgGradient() {
      return ConfigThemeService.getHeaderBackgroundImgGradient();
    }

    get headerMinHeight() {
      return `${ConfigThemeService.getHeaderMinHeight()} px`;
    }

    get isActivatedScrollHeaderEffect() {
      return ConfigThemeService.isActivatedScrollHeaderEffect();
    }

    get hideCloseButton() {
      return ConfigService.hideCloseButton();
    }

    /** ******************************************************************************************* */
    /**                                   TITTLE FOR BUTTONS                                        */
    /** ******************************************************************************************* */

    get closeConversationPanelButtonTitle() {
      return ConfigService.getCloseButtonTitle();
    }

  }
